import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

export function useUrlState() {
  const [params, setParams] = useSearchParams();
  const set = useCallback(
    (updates: Record<string, string | null | undefined>, replace = true) => {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          for (const [k, v] of Object.entries(updates)) {
            if (v === null || v === undefined || v === '') next.delete(k);
            else next.set(k, v);
          }
          return next;
        },
        { replace },
      );
    },
    [setParams],
  );
  return { params, set };
}

export function useCycleParam(): string | undefined {
  const [params] = useSearchParams();
  return params.get('cycle') ?? undefined;
}
